import { useMutation, useQueryClient } from "@tanstack/react-query";

import { removeToolBlacklistItem } from "./api";

// Аргументы DELETE: роль (для query+инвалидации) и имя инструмента.
export interface RemoveToolBlacklistItemArgs {
  readonly roleName: string;
  readonly toolName: string;
}

// DELETE запрета по имени инструмента. На успех инвалидируем список пары —
// строка исчезнет из таблицы. Ключ включает role_name (тот же ключ, что у
// useToolBlacklist).
export function useRemoveToolBlacklistItem(): ReturnType<
  typeof useMutation<void, Error, RemoveToolBlacklistItemArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, RemoveToolBlacklistItemArgs>({
    mutationFn: ({ roleName, toolName }) =>
      removeToolBlacklistItem(roleName, toolName),
    onSuccess: (_void, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["toolBlacklist", variables.roleName],
      });
    },
  });
}
